module.exports = __webpack_public_path__ + "img/11.56a6f067.png";